import React, { useState } from 'react'
import { Button } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEdit,
  faTrashCan,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons'
import { Store } from '../../../../utils/toast'
import LocationsModal from './locations-modal/LocationsModal'
import ConfirmDialog from '../../../../components/confirm-dialog/ConfirmDialog'
import './LocationsPage.scss'
import {
  useGetLocationsQuery,
  useDeleteLocationMutation,
} from '../../../../store/api/locationsApi'
import { ILocation } from '../../../../types/locations'

const c = 'locations-page'

const LocationsPage = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [location, setLocation] = useState<ILocation>()
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null)
  const { data: locations = [] } = useGetLocationsQuery()
  const [deleteLocation] = useDeleteLocationMutation()

  function handleDelete(locationId: string) {
    deleteLocation(locationId)
      .unwrap()
      .then(() => {
        Store.addNotification({
          title: 'SUCCESS',
          message: 'Sters cu succes!',
          container: 'top-center',
          type: 'success',
          insert: 'top',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: { duration: 1000, onScreen: true },
        })
      })
  }

  function handleEdit(location: ILocation) {
    setIsOpenEdit(true)
    setLocation(location)
  }

  const locationToDelete = locations.find((l) => l._id === confirmDeleteId)

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>Locații</div>
        <Button
          variant='contained'
          onClick={() => setIsOpen(true)}
          sx={{
            backgroundColor: 'var(--color-primary)',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
          }}
        >
          + Adaugă
        </Button>
      </div>

      <div className={`${c}__list`}>
        {locations.map((location) => (
          <div key={location._id} className={`${c}__list-item`}>
            <div className={`${c}__list-item-icon`}>
              <FontAwesomeIcon icon={faLocationDot} />
            </div>
            <div className={`${c}__list-item-info`}>
              <div className={`${c}__list-item-info-label`}>
                {location.label}
              </div>
              <div className={`${c}__list-item-info-price`}>
                {location.delivery_price} lei
              </div>
            </div>
            <div className={`${c}__list-item-actions`}>
              <button
                className={`${c}__list-item-actions-btn edit`}
                onClick={() => handleEdit(location)}
                title='Editează'
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                className={`${c}__list-item-actions-btn delete`}
                onClick={() => setConfirmDeleteId(location._id)}
                title='Șterge'
              >
                <FontAwesomeIcon icon={faTrashCan} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <ConfirmDialog
        open={!!confirmDeleteId}
        title='Șterge locație'
        message={`Ești sigur că vrei să ștergi "${locationToDelete?.label}"?`}
        onConfirm={() => {
          if (confirmDeleteId) handleDelete(confirmDeleteId)
          setConfirmDeleteId(null)
        }}
        onCancel={() => setConfirmDeleteId(null)}
      />

      <LocationsModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <LocationsModal
        isOpen={isOpenEdit}
        setIsOpen={setIsOpenEdit}
        data={location}
      />
    </div>
  )
}

export default LocationsPage
